import React, { useState, useEffect } from 'react';
import { Settings as SettingsIcon } from 'lucide-react';
import userApi, { UserProfile } from '../api/userApi';
import ProfileSettings from '../components/profile/ProfileSettings';
import { useLanguage } from '../context/LanguageContext';

export default function Settings() {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<UserProfile | null>(null);

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = async () => {
    setLoading(true);
    try {
      const data = await userApi.getProfile();
      setUser(data);
    } catch (error: any) {
      console.error('Error loading user data:', error);
      alert(error.message || 'Gagal memuat data');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSettings = async (settings: any) => {
    setLoading(true);
    try {
      await userApi.updateSettings(settings);
      alert('Pengaturan berhasil disimpan');
    } catch (error: any) {
      console.error('Error updating settings:', error);
      alert(error.message || 'Gagal menyimpan pengaturan');
    } finally {
      setLoading(false);
    }
  };

  if (loading && !user) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">Gagal memuat data</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 flex items-center gap-3">
          <SettingsIcon className="w-8 h-8" />
          {t('settings.title')}
        </h1>
        <p className="text-gray-500 mt-1">{t('settings.subtitle')}</p>
      </div>

      {/* Settings Content */}
      <div className="bg-white border rounded-lg">
        <div className="p-6">
          <ProfileSettings user={user} onUpdate={handleUpdateSettings} loading={loading} />
        </div>
      </div>
    </div>
  );
}
